import { initI18n } from '@argo/common/i18n'

// The insurance application's own words; the shared ones (sign-in,
// registration, the PIN, the nouns every screen needs) are in
// @argo/common/i18n.
export { setLanguage } from '@argo/common/i18n'

const mn = {
  app: 'Argo Даатгал', brandLine: 'Даатгал',

  // navigation
  cover: 'Даатгал', claims: 'Нөхөн төлбөр', queue: 'Нэхэмжлэлийн дараалал', products: 'Бүтээгдэхүүн', report: 'Тайлан',
  shortClaims: 'Нөхөн', shortQueue: 'Дараалал', shortProducts: 'Бараа',

  // cover
  myCover: 'Миний даатгал', buyCover: 'Даатгал авах', noCover: 'Одоогоор даатгал алга',
  sumInsured: 'Даатгалын дүн', coverLeft: 'Үлдсэн хамгаалалт', premiumWord: 'Хураамж',
  term: 'Хугацаа', days: '{{count}} хоног', starts: 'Эхэлсэн', ends: 'Дуусах',
  policyId: 'Гэрээний дугаар', product: 'Бүтээгдэхүүн',
  chooseProduct: 'Бүтээгдэхүүн сонгох', coverAmount: 'Даатгуулах дүн',
  youPay: 'Төлөх хураамж', rateLine: '{{rate}}% хураамжтай',
  buy: 'Худалдаж авах', cancelCover: 'Цуцлах',
  cancelled: 'Цуцалсан', refunded: 'Буцаасан хураамж',
  active: 'Идэвхтэй', expired: 'Дууссан',
  cancelConfirm: 'Энэ даатгалыг цуцлах уу?',
  cancelProRata: 'Үлдсэн хугацааны хураамжийг буцаан олгоно.',
  cancelNoRefund: 'Энэ бүтээгдэхүүн хураамж буцаадаггүй.',
  cancelClaimed: 'Нэхэмжлэл гаргасан даатгалыг цуцлах боломжгүй.',

  // claims
  myClaims: 'Миний нэхэмжлэл', makeClaim: 'Нөхөн төлбөр нэхэмжлэх', noClaims: 'Нэхэмжлэл алга',
  claimAmount: 'Нэхэмжлэх дүн', dateOfLoss: 'Эрсдэл учирсан огноо',
  evidence: 'Нотлох баримт', chooseFile: 'Файл сонгох', fileTypes: 'PDF, JPEG эсвэл PNG, 10 МБ хүртэл',
  claimed: 'Нэхэмжилсэн', paidWord: 'Төлсөн', outstanding: 'Төлөгдөөгүй',
  reportedOn: 'Мэдэгдсэн', incurredOn: 'Эрсдэл учирсан', closedOn: 'Хаасан',
  open: 'Хүлээгдэж буй', settled: 'Шийдвэрлэсэн', rejected: 'Татгалзсан',
  payments: 'Төлөлт', decisions: 'Шийдвэр', downloadEvidence: 'Нотлох баримт татах',
  claimFiled: 'Нэхэмжлэл бүртгэгдлээ', noPolicyToClaim: 'Идэвхтэй даатгал алга',

  // the insurer's desks
  openClaims: 'Хүлээгдэж буй нэхэмжлэл', noOpenClaims: 'Хүлээгдэж буй нэхэмжлэл алга',
  holder: 'Даатгуулагч', pay: 'Төлөх', settle: 'Хаах', reject: 'Татгалзах',
  amountToPay: 'Төлөх дүн', reason: 'Шалтгаан', reasonRequired: 'Татгалзах шалтгаанаа бичнэ үү',
  settleNote: 'Төлөгдөөгүй үлдсэн дүн хаагдаж, хамгаалалт руу буцна.',
  defineProduct: 'Бүтээгдэхүүн үүсгэх', code: 'Код', name: 'Нэр', description: 'Тайлбар',
  insurerAccount: 'Даатгагчийн данс', coverageLimit: 'Дээд хамгаалалт', termDays: 'Хугацаа (хоног)',
  rateBps: 'Хураамжийн хувь (bps)', refundMode: 'Цуцлалт', refundProRata: 'Хугацаагаар буцаана',
  refundNone: 'Буцаахгүй', onSale: 'Борлуулалтад', saved: 'Хадгаллаа',
  productHint: 'Хураамж = даатгалын дүн × хувь. Хамгаалалтын хязгаар, хугацаа, цуцлалтыг блокчэйн хадгална.',

  // the report
  underwriting: 'Андеррайтингийн тайлан', asOf: 'Тайлант огноо', insurerFilter: 'Даатгагч', allInsurers: 'Бүгд',
  writtenPremium: 'Бичигдсэн хураамж', earnedPremium: 'Орлогод тооцсон хураамж',
  unearnedPremium: 'Хуваарилагдаагүй хураамжийн нөөц',
  paidClaims: 'Төлсөн нөхөн төлбөр', outstandingClaims: 'Төлөгдөөгүй нөхөн төлбөр',
  ibnr: 'Учирсан ч мэдэгдээгүй нөөц (IBNR)', totalClaims: 'Нийт нөхөн төлбөр',
  operatingExpenses: 'Үйл ажиллагааны зардал', margin: 'Андеррайтингийн ашиг',
  ledgerCash: 'Блокчэйн дэх бэлэн мөнгө', triangle: 'Хөгжлийн гурвалжин',
  policyAge: 'Нас', developmentDays: 'Хөгжлийн хоног', factor: 'Коэффициент',
  reportedTo: 'Мэдэгдсэн', ultimate: 'Эцсийн', policiesCount: 'Гэрээ', claimsCount: 'Нэхэмжлэл',
  ibnrNote: 'IBNR-ийг сүүлийн хөгжлийн үе хүртэл сунгаж (chain ladder) тооцов.',

  // the issuer's desk: putting settlement money on the ledger
  fundAccount: 'Данс цэнэглэх', mint: 'Гаргах', minted: 'Гарлаа',
  fundHint: 'STABLE бол энэ дэвтрийн төлбөрийн хэрэгсэл. Банкны шилжүүлэг баталгаажсаны дараа л гаргана.',

  // notices the product and the ledger require
  coverNotice: 'Хураамж нэг удаа төлөгдөж, блокчэйнд бичигдэнэ. Хамгаалалт гүйлгээ баталгаажсан үеэс эхэлнэ.',
  coverNoticeRefund: 'Цуцлахад үлдсэн хугацааны хураамж буцна; нэхэмжлэл гарсан бол цуцлах боломжгүй.',
  claimNotice: 'Нэхэмжлэл гаргасан нь төлбөр баталгаажсан гэсэн үг биш. Даатгагч шийдвэрлэнэ.',
  claimNoticeEvidence: 'Хавсаргасан баримтын хурууны хээ (SHA-256) блокчэйнд бичигдэж, дараа нь өөрчлөгдөхгүй.',
  // Phase 1: [Balance] [Products] [Profile]
  tabBalance: 'Үлдэгдэл', catalog: 'Бүтээгдэхүүн', profile: 'Профайл',
  productsDesk: 'Бүтээгдэхүүний удирдлага', shortDesk: 'Удирдлага',
  heldAsBond: 'Барьцаанд', owedOnClaims: 'Нэхэмжлэлээр авах', testFigure: 'туршилт',
  bondsForMe: 'Миний түрээслүүлсэн байрны барьцаа', renter: 'Түрээслэгч', landlord: 'Түрээслүүлэгч',
  inEscrow: 'Барьцаанд байгаа', releaseOn: 'Буцаагдах өдөр', releasedWord: 'Буцаагдсан дүн', released: 'Буцаасан',
  referralIncome: 'Зуучлалын орлого', referredSales: '{{count}} борлуулалт', allClaims: 'Бүх нэхэмжлэл',
  bondWord: 'Барьцаа', coverWord: 'Даатгал', details: 'Дэлгэрэнгүй',
  getPrice: 'Үнэ гаргах', bondAmount: 'Барьцааны дүн', landlordUsername: 'Түрээслүүлэгчийн хэрэглэгчийн нэр',
  referralCode: 'Зуучлагчийн код', optional: 'заавал биш', referredBy: 'Зуучлагч',
  vehicle: 'Тээврийн хэрэгсэл', addVehicle: 'Машин нэмэх', chooseVehicle: 'Машин сонгох',
  licenceYear: 'Жолооны үнэмлэх авсан он', needsTitle: 'Үнэ гаргахад дараах мэдээлэл хэрэгтэй',
  priceUsed: 'Энэ үнийг гаргасан мэдээлэл', howPriced: 'Үнэ хэрхэн бүрдсэн', baseAmount: 'Суурь',
  confirmFacts: 'Дээрх мэдээлэл үнэн зөв гэдгийг баталж байна',
  falseInfo: 'Худал мэдээлэл өгвөл ирээдүйн нөхөн төлбөр буурч болно.',
  quoteExpires: 'Энэ үнэ {{time}} хүртэл хүчинтэй', editDetails: 'Мэдээлэл засах', fee: 'Хураамж',
  bondNotice: 'Барьцаа таны мөнгө хэвээр: түрээс дууссанаас хойш {{days}} хоногт түрээслүүлэгч нэхэмжлэл гаргаагүй бол буцаан олгоно.',
  youPayTotal: 'Нийт төлөх',
  age: 'Нас', sex: 'Хүйс', male: 'Эрэгтэй', female: 'Эмэгтэй', fromRegNo: 'Регистрийн дугаараас', birthDate: 'Төрсөн огноо',
  unknownRegNo: 'Регистрийн дугаараас уншиж чадсангүй — ажилтанд хандана уу',
  plate: 'Улсын дугаар', vehicleClass: 'Ангилал', makeModel: 'Марк, загвар', yearMade: 'Үйлдвэрлэсэн он',
  engineCc: 'Хөдөлгүүр (cc)', vehicleValue: 'Үнэлгээ',
  pricingDetails: 'Үнэд хэрэглэгдэх мэдээлэл',
  pricingDetailsHint: 'Зөвхөн үнэд нөлөөлөх мэдээллийг асууна. Өөрчлөгдвөл энд засна уу.',
  remove: 'Хасах', edit: 'Засах', noVehicles: 'Машин бүртгээгүй',
  myCodes: 'Миний зуучлалын код', earned: 'Олсон',
  policyDetail: 'Гэрээ', moveInEvidence: 'Нүүж орох үеийн байдал', attachFile: 'Файл хавсаргах', noteWord: 'Тэмдэглэл',
  endLease: 'Түрээс дууссаныг бүртгэх',
  endLeaseConfirm: 'Хамгаалалт өнөөдөр дуусч, түрээслүүлэгчийн нэхэмжлэх хугацаа өнөөдрөөс эхэлнэ.',
  escrowAccount: 'Эскроу данс', bondsDesk: 'Идэвхтэй барьцаа', noBonds: 'Идэвхтэй барьцаа алга',
  kindLabel: 'Төрөл', kindCover: 'Даатгал', kindBond: 'Барьцаа', releaseDays: 'Нэхэмжлэх хугацаа (хоног)',
  commissionCap: 'Шимтгэлийн дээд хувь (bps)', referralDefault: 'Зуучлалын анхдагч хувь (bps)',
  tariff: 'Тариф', method: 'Арга', paramsJson: 'Параметр (JSON)', saveTariff: 'Тариф хадгалах',
  referralCodes: 'Зуучлалын код', newCode: 'Шинэ код', referrerAccount: 'Шимтгэл авах данс', labelWord: 'Шошго',
  rateFor: 'Хувь', disable: 'Идэвхгүй болгох', disabledWord: 'Идэвхгүй', setRate: 'Хувь тогтоох',
  // the PIN panel — these lived only in the exchange's own strings
  pinSet: 'Тохируулсан', pinNotSet: 'Тохируулаагүй', currentPin: 'Одоогийн ПИН', newPin: 'Шинэ ПИН',
  pinHint: '4-8 оронтой тоо. Мөнгөн гүйлгээ бүрт шаардана.',
}

const en: typeof mn = {
  app: 'Argo Insurance', brandLine: 'Insurance',

  cover: 'Cover', claims: 'Claims', queue: 'Claims queue', products: 'Products', report: 'Report',
  shortClaims: 'Claims', shortQueue: 'Queue', shortProducts: 'Products',

  myCover: 'My cover', buyCover: 'Buy cover', noCover: 'No cover yet',
  sumInsured: 'Sum insured', coverLeft: 'Cover left', premiumWord: 'Premium',
  term: 'Term', days: '{{count}} days', starts: 'Started', ends: 'Ends',
  policyId: 'Policy', product: 'Product',
  chooseProduct: 'Choose a product', coverAmount: 'Amount of cover',
  youPay: 'You pay', rateLine: 'priced at {{rate}}%',
  buy: 'Buy', cancelCover: 'Cancel',
  cancelled: 'Cancelled', refunded: 'Refunded',
  active: 'Active', expired: 'Expired',
  cancelConfirm: 'Cancel this cover?',
  cancelProRata: 'The premium for the unexpired term comes back.',
  cancelNoRefund: 'This product refunds nothing on cancellation.',
  cancelClaimed: 'Cover that has been claimed on cannot be cancelled.',

  myClaims: 'My claims', makeClaim: 'Make a claim', noClaims: 'No claims',
  claimAmount: 'Amount claimed', dateOfLoss: 'Date of loss',
  evidence: 'Evidence', chooseFile: 'Choose a file', fileTypes: 'PDF, JPEG or PNG, up to 10 MB',
  claimed: 'Claimed', paidWord: 'Paid', outstanding: 'Outstanding',
  reportedOn: 'Reported', incurredOn: 'Loss', closedOn: 'Closed',
  open: 'Open', settled: 'Settled', rejected: 'Rejected',
  payments: 'Payments', decisions: 'Decisions', downloadEvidence: 'Download evidence',
  claimFiled: 'Claim filed', noPolicyToClaim: 'No cover to claim against',

  openClaims: 'Open claims', noOpenClaims: 'Nothing waiting',
  holder: 'Policyholder', pay: 'Pay', settle: 'Settle', reject: 'Reject',
  amountToPay: 'Amount to pay', reason: 'Reason', reasonRequired: 'A rejection needs a reason',
  settleNote: 'Anything unpaid is written off and returns to the cover.',
  defineProduct: 'Define a product', code: 'Code', name: 'Name', description: 'Description',
  insurerAccount: 'Insurer account', coverageLimit: 'Maximum cover', termDays: 'Term (days)',
  rateBps: 'Rate (basis points)', refundMode: 'Cancellation', refundProRata: 'Pro rata refund',
  refundNone: 'No refund', onSale: 'On sale', saved: 'Saved',
  productHint: 'Premium = cover × rate. The chain holds the cover limit, the term and the refund rule.',

  underwriting: 'Underwriting report', asOf: 'As at', insurerFilter: 'Insurer', allInsurers: 'All',
  writtenPremium: 'Written premium', earnedPremium: 'Earned premium',
  unearnedPremium: 'Unearned premium reserve',
  paidClaims: 'Paid claims', outstandingClaims: 'Outstanding claims',
  ibnr: 'Incurred but not reported (IBNR)', totalClaims: 'Total claims',
  operatingExpenses: 'Operating expenses', margin: 'Underwriting margin',
  ledgerCash: 'Held on the ledger', triangle: 'Development triangle',
  policyAge: 'Age', developmentDays: 'Development days', factor: 'Factor',
  reportedTo: 'Reported', ultimate: 'Ultimate', policiesCount: 'Policies', claimsCount: 'Claims',
  ibnrNote: 'IBNR is the chain-ladder ultimate less what has been reported.',

  fundAccount: 'Fund an account', mint: 'Issue', minted: 'Issued',
  fundHint: 'STABLE is this ledger\'s settlement money. Issue it only against a bank transfer that has cleared.',

  coverNotice: 'The premium is paid once and written to the ledger. Cover starts when the transaction commits.',
  coverNoticeRefund: 'Cancelling returns the premium for the unexpired term; cover that has been claimed on cannot be cancelled.',
  claimNotice: 'Filing a claim is not a promise to pay. The insurer decides it.',
  claimNoticeEvidence: 'The fingerprint (SHA-256) of the file you attach is written to the ledger and cannot change afterwards.',
  tabBalance: 'Balance', catalog: 'Products', profile: 'Profile',
  productsDesk: 'Product desk', shortDesk: 'Desk',
  heldAsBond: 'Held as bond', owedOnClaims: 'Owed on claims', testFigure: 'test',
  bondsForMe: 'Bonds where I am the landlord', renter: 'Renter', landlord: 'Landlord',
  inEscrow: 'Held', releaseOn: 'Returned on', releasedWord: 'Returned', released: 'Released',
  referralIncome: 'Referral income', referredSales: '{{count}} sales', allClaims: 'All claims',
  bondWord: 'Bond', coverWord: 'Cover', details: 'Details',
  getPrice: 'Get a price', bondAmount: 'Bond amount', landlordUsername: "Landlord's username",
  referralCode: 'Referral code', optional: 'optional', referredBy: 'Referred by',
  vehicle: 'Vehicle', addVehicle: 'Add a vehicle', chooseVehicle: 'Choose a vehicle',
  licenceYear: 'Year you began driving', needsTitle: 'To price this we need',
  priceUsed: 'What this price is based on', howPriced: 'How the price was reached', baseAmount: 'Base',
  confirmFacts: 'I confirm these details are true',
  falseInfo: 'False information may reduce a future claim.',
  quoteExpires: 'This price holds until {{time}}', editDetails: 'Edit details', fee: 'Fee',
  bondNotice: 'The bond stays your money: it comes back {{days}} days after the lease ends unless the landlord has claimed.',
  youPayTotal: 'You pay in total',
  age: 'Age', sex: 'Sex', male: 'Male', female: 'Female', fromRegNo: 'From your registration number', birthDate: 'Born',
  unknownRegNo: 'Could not be read from your registration number — contact us',
  plate: 'Plate', vehicleClass: 'Class', makeModel: 'Make and model', yearMade: 'Year made',
  engineCc: 'Engine (cc)', vehicleValue: 'Value',
  pricingDetails: 'Details used for pricing',
  pricingDetailsHint: 'Only what changes a price is asked for. Correct it here whenever it changes.',
  remove: 'Remove', edit: 'Edit', noVehicles: 'No vehicles yet',
  myCodes: 'My referral codes', earned: 'Earned',
  policyDetail: 'Policy', moveInEvidence: 'Condition at move-in', attachFile: 'Attach a file', noteWord: 'Note',
  endLease: 'Record the lease ending',
  endLeaseConfirm: "Cover ends today and the landlord's window to claim starts today.",
  escrowAccount: 'Escrow', bondsDesk: 'Bonds in force', noBonds: 'No bonds in force',
  kindLabel: 'Kind', kindCover: 'Cover', kindBond: 'Bond', releaseDays: 'Claim window (days)',
  commissionCap: 'Commission cap (bps)', referralDefault: 'Default referral rate (bps)',
  tariff: 'Tariff', method: 'Method', paramsJson: 'Parameters (JSON)', saveTariff: 'Save tariff',
  referralCodes: 'Referral codes', newCode: 'New code', referrerAccount: 'Paid to account', labelWord: 'Label',
  rateFor: 'Rate', disable: 'Disable', disabledWord: 'Disabled', setRate: 'Set rate',
  pinSet: 'Set', pinNotSet: 'Not set', currentPin: 'Current PIN', newPin: 'New PIN',
  pinHint: '4 to 8 digits. Required for every money movement.',
}

export default initI18n({ mn, en })
